import {
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse,
} from '@mui/material';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PersonIcon from '@mui/icons-material/Person';
import CodeIcon from '@mui/icons-material/Code';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Visibility from '../../../common/components/Visibility.tsx';
import { NavigationRoutes } from '../../router/routes.ts';
import { SideBarMenuProps } from './SideBarMenuProps.ts';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { alpha } from '@mui/material/styles';

const SideBarUser = ({ handleMenuClick }: SideBarMenuProps) => {
    const [openMenu, setOpenMenu] = useState<{ [key: string]: boolean }>({});
    const location = useLocation();
    const pathname = location.pathname;

    const isTransactionActive = pathname.startsWith(
        NavigationRoutes.transaction
    );
    const isProfileActive = pathname.startsWith(NavigationRoutes.profile);
    const isSupportActive = pathname.startsWith(NavigationRoutes.support);
    const isDevThemeActive = pathname.startsWith(NavigationRoutes.devTheme);
    const isDevMessageActive = pathname.startsWith(NavigationRoutes.devMessage);

    const handleToggle = (menu: string) => {
        setOpenMenu((prev) => ({ ...prev, [menu]: !prev[menu] }));
    };

    return (
        <nav>
            <List>
                <ListItemButton
                    sx={{ my: 0.5 }}
                    selected={isTransactionActive}
                    onClick={() =>
                        handleMenuClick(NavigationRoutes.transaction)
                    }
                >
                    <ListItemIcon sx={{ minWidth: 34 }}>
                        <MenuBookIcon />
                    </ListItemIcon>
                    <ListItemText primary="Förbrukningsjournal" />
                </ListItemButton>

                <ListItemButton
                    sx={{ my: 0.5 }}
                    selected={isSupportActive}
                    onClick={() => handleMenuClick(NavigationRoutes.support)}
                >
                    <ListItemIcon sx={{ minWidth: 34 }}>
                        <ContactSupportIcon />
                    </ListItemIcon>
                    <ListItemText primary="Support" />
                </ListItemButton>

                <ListItemButton
                    sx={{ my: 0.5 }}
                    selected={isProfileActive}
                    onClick={() => handleMenuClick(NavigationRoutes.profile)}
                >
                    <ListItemIcon sx={{ minWidth: 34 }}>
                        <PersonIcon />
                    </ListItemIcon>
                    <ListItemText primary="Min profil" />
                </ListItemButton>

                <Visibility visible={import.meta.env.MODE === 'development'}>
                    <ListItemButton
                        sx={{ my: 0.5 }}
                        selected={isDevThemeActive || isDevMessageActive}
                        onClick={() => handleToggle('dev')}
                    >
                        <ListItemIcon sx={{ minWidth: 34 }}>
                            <CodeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Development" />
                        {openMenu['dev'] ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={openMenu['dev']} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding sx={{ mt: 0.5 }}>
                            <ListItemButton
                                sx={(theme) => ({
                                    ml: 2,
                                    pl: 1,
                                    py: 0.5,
                                    minHeight: 36,
                                    borderRadius: 1,
                                    '&.Mui-selected': {
                                        borderLeft: '3px solid',
                                        borderColor: theme.palette.primary.main,
                                        backgroundColor: alpha(
                                            theme.palette.primary.main,
                                            0.08
                                        ),
                                    },
                                    '&:hover': {
                                        backgroundColor: alpha(
                                            theme.palette.action.hover,
                                            0.04
                                        ),
                                    },
                                    mb: 0.5,
                                })}
                                selected={isDevThemeActive}
                                onClick={() =>
                                    handleMenuClick(NavigationRoutes.devTheme)
                                }
                            >
                                <ListItemText
                                    inset
                                    primary="Themes-page"
                                    slotProps={{
                                        primary: {
                                            fontSize: '0.875rem',
                                            color: isDevThemeActive
                                                ? 'primary.main'
                                                : 'text.secondary',
                                            fontWeight: isDevThemeActive
                                                ? 500
                                                : 400,
                                        },
                                    }}
                                />
                            </ListItemButton>
                            <ListItemButton
                                sx={(theme) => ({
                                    ml: 2,
                                    pl: 1,
                                    py: 0.5,
                                    minHeight: 36,
                                    borderRadius: 1,
                                    '&.Mui-selected': {
                                        borderLeft: '3px solid',
                                        borderColor: theme.palette.primary.main,
                                        backgroundColor: alpha(
                                            theme.palette.primary.main,
                                            0.08
                                        ),
                                    },
                                    '&:hover': {
                                        backgroundColor: alpha(
                                            theme.palette.action.hover,
                                            0.04
                                        ),
                                    },
                                })}
                                selected={isDevMessageActive}
                                onClick={() =>
                                    handleMenuClick(NavigationRoutes.devMessage)
                                }
                            >
                                <ListItemText
                                    inset
                                    primary="Message page"
                                    slotProps={{
                                        primary: {
                                            fontSize: '0.875rem',
                                            color: isDevMessageActive
                                                ? 'primary.main'
                                                : 'text.secondary',
                                            fontWeight: isDevMessageActive
                                                ? 500
                                                : 400,
                                        },
                                    }}
                                />
                            </ListItemButton>
                        </List>
                    </Collapse>
                </Visibility>
            </List>
        </nav>
    );
};

export default SideBarUser;
